export const MEDIA_CARD_WIDTH = 240;
export const MEDIA_CARD_HEIGHT = 240;
export const MEDIA_CARD_IMAGE_HEIGHT = 196;
export const MEDIA_CARD_MARGIN = 10;

export const MEDIA_LIBRARY_PADDING = 20;

export const MAX_LINK_DISPLAY_LENGTH = 28;

export const DRAFT_MEDIA_FILES = 'DRAFT_MEDIA_FILES';
